import Promise from './Promise';

class Event {
    constructor() {
        this.events = {};
    }

    trigger(event, ...args) {
        return Promise.chained(this.events[event] || [], this, args);
    }

    on(event, clbk) {
        if (!this.events[event]) {
            this.events[event] = [];
        }

        this.events[event].push(clbk);
    }
}

export default Event;
